// Basis Website GSAP ================================================================================

import gsap, { Power3 } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

let mobile_breakpoint = '800';
let mobile_width = window.innerWidth;
let disableMobile = mobile_breakpoint > mobile_width ? ':not(.disable-effects-mobile)' : '';

gsap.registerPlugin(ScrollTrigger);

ScrollTrigger.defaults({
    scrub: true,
    start: 'top 100%-=200px', // 'top 90%',
    toggleActions: 'play none none none', // "onEnter onLeave onEnterBack onLeaveBack"
    /* markers: {
        startColor: "green",
        endColor: "green"
    } */
});

const waitForImage = (item, animationFunction) => {
    let img = item.querySelector('img');
    if (!img) {
        animationFunction(item);
    } else if (img.complete && img.naturalHeight !== 0) {
        animationFunction(item);
    } else {
        img.onload = () => animationFunction(item);
    }
};

// Animate-In Klassen für Animation im CSS zuweisen ----------------------------------------------------------------------------------------------------

const element = gsap.utils.toArray('#main .mod_article .content-wrapper > *');
element.forEach((item) => {
    waitForImage(item, () => {
        ScrollTrigger.create({
            trigger: item,
            onEnter: () => item.classList.add('animate-in'),
            /* markers: {
                startColor: "green",
                endColor: "red"
            } */
        });
    });
});

// play alone fade slide ins ==========================================================================================

const slideUp = gsap.utils.toArray('.slide-up:not(.content-accordion)' + disableMobile);
slideUp.forEach((item) => {
    waitForImage(item, () => {
        gsap.from(item, {
            scrollTrigger: {
                trigger: item,
                scrub: false,
                end: 'top 90%',
            },
            y: 100,
            opacity: 0,
            duration: duration,
            ease: Power3.easeOut,
        });
    });
});

const slideUpAccordion = gsap.utils.toArray(
    '.slide-up.content-accordion .accordion .handorgel__header, .slide-up.headline' + disableMobile
);

slideUpAccordion.forEach((item) => {
    waitForImage(item, () => {
        gsap.from(item, {
            scrollTrigger: {
                trigger: item,
                scrub: false,
                end: 'top 90%',
            },
            y: 100,
            opacity: 0,
            duration: duration,
            ease: Power3.easeOut,
        });
    });
});

const slideLeft = gsap.utils.toArray('.slide-left' + disableMobile);
slideLeft.forEach((item) => {
    waitForImage(item, () => {
        gsap.from(item, {
            scrollTrigger: {
                trigger: item,
                scrub: false,
                end: 'top 80%',
            },
            x: 100,
            opacity: 0,
            duration: 1.0,
            ease: Power3.easeOut,
        });
    });
});

const slideRight = gsap.utils.toArray('.slide-right' + disableMobile);
slideRight.forEach((item) => {
    waitForImage(item, () => {
        gsap.from(item, {
            scrollTrigger: {
                trigger: item,
                scrub: false,
                end: 'top 80%',
            },
            x: -100,
            opacity: 0,
            duration: 1.0,
            ease: Power3.easeOut,
        });
    });
});

// automatic image reveal ==========================================================================================

let revealUpTrigger = document.querySelectorAll('.reveal-up' + disableMobile);
revealUpTrigger.forEach((item) => {
    waitForImage(item, () => {
        let container = item.querySelector('.image_container');
        let image = item.querySelector('img');
        let tl = gsap.timeline({
            scrollTrigger: {
                // play alone
                trigger: item,
                scrub: false,
                end: 'top 70%',
            },
        });
        tl.from(container, {
            yPercent: 100,
            autoAlpha: 0,
            duration: 1.5,
            ease: Power3.easeOut,
        });
        tl.from(image, {
            yPercent: -100,
            transformOrigin: '50% 100%',
            duration: 1.5,
            scale: 1.5,
            delay: -1.5,
            opacity: 0,
            ease: Power3.easeOut,
        });
    });
});

let revealRightTrigger = document.querySelectorAll('.reveal-right' + disableMobile);
revealRightTrigger.forEach((item) => {
    waitForImage(item, () => {
        let container = item.querySelector('.image_container');
        let image = item.querySelector('img');
        let tl = gsap.timeline({
            scrollTrigger: {
                // play alone
                trigger: item,
                scrub: false,
                end: 'top 70%',
            },
        });
        tl.from(container, {
            xPercent: -100,
            autoAlpha: 0,
            duration: 1.5,
            ease: Power3.easeOut,
        });
        tl.from(image, {
            xPercent: 100,
            transformOrigin: '0% 50%',
            duration: 1.5,
            scale: 1.5,
            delay: -1.5,
            opacity: 0,
            ease: Power3.easeOut,
        });
    });
});

let revealLeftTrigger = document.querySelectorAll('.reveal-left' + disableMobile);
revealLeftTrigger.forEach((item) => {
    waitForImage(item, () => {
        let container = item.querySelector('.image_container');
        let image = item.querySelector('img');
        let tl = gsap.timeline({
            scrollTrigger: {
                // play alone
                trigger: item,
                scrub: false,
                end: 'top 70%',
            },
        });
        tl.from(container, {
            xPercent: 100,
            autoAlpha: 0,
            duration: 1.5,
            ease: Power3.easeOut,
        });
        tl.from(image, {
            xPercent: -100,
            transformOrigin: '100% 50%',
            duration: 1.5,
            scale: 1.5,
            delay: -1.5,
            opacity: 0,
            ease: Power3.easeOut,
        });
    });
});

// scrub fade slide ins ==========================================================================================

const scrubSlideUp = gsap.utils.toArray('.scrub-slide-up' + disableMobile);
scrubSlideUp.forEach((item) => {
    waitForImage(item, () => {
        gsap.from(item, {
            scrollTrigger: {
                trigger: item,
                start: 'top 100%',
                end: 'top 90%',
            },
            y: 100,
            opacity: 0,
        });
    });
});

const scrubSlideLeft = gsap.utils.toArray('.scrub-slide-left' + disableMobile);
scrubSlideLeft.forEach((item) => {
    waitForImage(item, () => {
        gsap.from(item, {
            scrollTrigger: {
                trigger: item,
                start: 'top 100%',
                end: 'top 90%',
            },
            x: 100,
            opacity: 0,
        });
    });
});

const scrubSlideRight = gsap.utils.toArray('.scrub-slide-right' + disableMobile);
scrubSlideRight.forEach((item) => {
    waitForImage(item, () => {
        gsap.from(item, {
            scrollTrigger: {
                trigger: item,
                start: 'top 100%',
                end: 'top 90%',
            },
            x: -100,
            opacity: 0,
        });
    });
});

// scrub image reveal ==========================================================================================

let scrubRevealUpTrigger = document.querySelectorAll('.scrub-reveal-up' + disableMobile);
scrubRevealUpTrigger.forEach((item) => {
    waitForImage(item, () => {
        let container = item.querySelector('.image_container');
        let image = item.querySelector('img');
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: item,
                start: 'top 90%',
                end: 'top 60%',
            },
        });
        tl.from(container, {
            yPercent: 30,
            autoAlpha: 0,
            duration: 1.5,
        });
        tl.from(image, {
            yPercent: -30,
            transformOrigin: '50% 100%',
            duration: 1.5,
            scale: 1.1,
            delay: -1.5,
            opacity: 0,
        });
    });
});

let scrubRevealRightTrigger = document.querySelectorAll('.scrub-reveal-right' + disableMobile);
scrubRevealRightTrigger.forEach((item) => {
    waitForImage(item, () => {
        let container = item.querySelector('.image_container');
        let image = item.querySelector('img');
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: item,
                start: 'top 90%',
                end: 'top 60%',
            },
        });
        tl.from(container, {
            xPercent: -50,
            autoAlpha: 0,
            duration: 1.5,
        });
        tl.from(image, {
            xPercent: 50,
            transformOrigin: '0% 50%',
            duration: 1.5,
            scale: 1.1,
            delay: -1.5,
            opacity: 0,
        });
    });
});

let scrubRevealLeftTrigger = document.querySelectorAll('.scrub-reveal-left' + disableMobile);
scrubRevealLeftTrigger.forEach((item) => {
    waitForImage(item, () => {
        let container = item.querySelector('.image_container');
        let image = item.querySelector('img');
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: item,
                start: 'top 90%',
                end: 'top 60%',
            },
        });
        tl.from(container, {
            xPercent: 50,
            autoAlpha: 0,
            duration: 1.5,
        });
        tl.from(image, {
            xPercent: -50,
            transformOrigin: '100% 50%',
            duration: 1.5,
            scale: 1.1,
            delay: -1.5,
            opacity: 0,
        });
    });
});

// fade ins ==========================================================================================

const fadeIn = gsap.utils.toArray('.fade-in' + disableMobile);
fadeIn.forEach((item) => {
    waitForImage(item, () => {
        gsap.from(item, {
            scrollTrigger: {
                trigger: item,
                scrub: false,
                toggleActions: 'play none reverse none',
                start: 'top 90%',
                end: 'top 90%',
            },
            opacity: 0,
            duration: 1,
        });
    });
});

const scrubFadeIn = gsap.utils.toArray('.scrub-fade-in' + disableMobile);
scrubFadeIn.forEach((item) => {
    waitForImage(item, () => {
        gsap.from(item, {
            scrollTrigger: {
                trigger: item,
                start: 'top 100%',
                end: 'top 90%',
            },
            opacity: 0,
        });
    });
});

// Parallax Effekte ==========================================================================================

const parallaxBackground = gsap.utils.toArray('.parallax' + disableMobile); // Parallax Backgrounds mit genauer Ausrichtung im Artikel
parallaxBackground.forEach((item) => {
    waitForImage(item, () => {
        const parallaxContainer = item.querySelector('.background');
        gsap.fromTo(
            parallaxContainer,
            {
                y: '-36vh', // -3/4 of value
            },
            {
                y: '12vh', // 1/4 of value
                scrollTrigger: {
                    trigger: item,
                    start: 'center 200%',
                    end: 'center -100%',
                },
            }
        );
    });
});

const parallaxForegroundElement = gsap.utils.toArray('.parallax-foreground'); // Element "im Vordergrund"
parallaxForegroundElement.forEach((item) => {
    waitForImage(item, () => {
        const moveContainer = item.querySelector('.content_inside');
        gsap.fromTo(
            moveContainer,
            {
                y: '-9vh', // -3/4 of value
            },
            {
                y: '3vh', // 1/4 of value
                scrollTrigger: {
                    trigger: item,
                    start: 'top 80%',
                    end: 'bottom 20%',
                },
            }
        );
    });
});

// ================================================================================

window.addEventListener('load', () => {
    ScrollTrigger.refresh(true);
});

window.addEventListener('resize', () => {
    ScrollTrigger.refresh(true);
});
